import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, EffectFade, Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "../../styles/Slider-swiper.css";

// Importa tus imágenes aquí
import saraDesktop from "./../../imagenes/slider/saras-desktop.jpg";
import saraMobile from "./../../imagenes/slider/saras-mobile.jpg";
import creditoFutuconfianzaDesktop from "./../../imagenes/slider/credito-futuconfianza-desktop.jpg";
import creditoFutuconfianzaMobile from "./../../imagenes/slider/credito-futuconfianza-mobile.png";
// import decimosDesktop from "./../../imagenes/slider/decimos-desktop.png";
// import decimosMobile from "./../../imagenes/slider/decimos-mobile.png";
// import creditoFutuautoMobile from "./../../imagenes/slider/credito-futuauto-mobile.jpg";
// import creditoFutuautoDesktop from "./../../imagenes/slider/credito-futuauto-desktop.png";
import cuentaAhorroDesktop from "./../../imagenes/slider/beneficios-desktop.png";
import cuentaAhorroMobile from "./../../imagenes/slider/beneficios-mobile.png";
import ahorroInclusionDesktop from "./../../imagenes/slider/ahorro-inclusion-desktop.jpg";
import ahorroInclusionMobile from "./../../imagenes/slider/ahorro-inclusion-mobile.png";
import ahorroCampoDesktop from "./../../imagenes/slider/ahorro-campo-desktop.png";
import ahorroCampoMobile from "./../../imagenes/slider/ahorro-campo-mobile.jpg";
import creditoPremiumDesktop from "./../../imagenes/slider/credito-premium-desktop.png";
import creditoPremiumMobile from "./../../imagenes/slider/credito-premium-mobile.png";
import creditoFutuUnidoDesktop from "./../../imagenes/slider/credito-futu-unido-desktop.png";
import creditoFutuUnidoMobile from "./../../imagenes/slider/credito-futu-unido-mobile.png";
// import creditoFutuSobreRuedaDesktop from "./../../imagenes/slider/credito-futuro-sobre-ruedas-desktop.png";
// import creditoFutuSobreRuedaMobile from "./../../imagenes/slider/credito-futuro-sobre-ruedas-mobile.png";
// import creditoFutuNavidenoDesktop from "./../../imagenes/slider/credito-futu-navideno-desktop.png";
// import creditoFutuNavidenoMobile from "./../../imagenes/slider/credito-futu-navideno-mobile.png";
// import creditoecofuturoDesktop from "./../../imagenes/slider/credito-eco-futuro-desktop.png";
// import creditoecofuturoMobile from "./../../imagenes/slider/credito-eco-futuro-mobile.jpg";
import creditofutuaniversarioDesktop from "./../../imagenes/slider/credito-futuaniversario-desktop.png";
import creditofutuaniversarioMobile from "./../../imagenes/slider/credito-futuaniversario-mobile.png";
import educacionFinancieraDesktop from "./../../imagenes/slider/educacion-financiera-desktop.png";
import educacionFinancieraMobile from "./../../imagenes/slider/educacion-financiera-mobile.png";
import medicinaGeneralDesktop from "./../../imagenes/slider/medicinageneral-desktopl.jpg";
import medicinaGeneralMobile from "./../../imagenes/slider/medicinageneral-mobile.jpg";
import creditoenlineaDesktop from "./../../imagenes/slider/creditoenlinea-desktop.png";
import creditoenlineaMobile from "./../../imagenes/slider/creditoenlinea-mobile.jpg";
import creditoFutuHogarDesktop from "./../../imagenes/slider/creditoFutuHogar-desktop.png";
import creditoFutuHogarMobile from "./../../imagenes/slider/creditoFutuHogar-mobile.png";
// import invierteutilidadesDesktop from "./../../imagenes/slider/invierte-utilidades-desktop.png";
// import invierteutilidadesMobile from "./../../imagenes/slider/invierte-utilidades-mobile.png";
// import facilitoDesktop from "./../../imagenes/slider/facilito-desktop.png";
import facilitoDesktop2 from "./../../imagenes/slider/facilito-desktop.png";
import facilitoMobile from "./../../imagenes/slider/facilito-mobile.png";
import acumulaPuntoDesktop from "./../../imagenes/slider/acumulaPuntos-desktop.png";
import acumulaPuntoMobile from "./../../imagenes/slider/acumula-puntos-Mobile.jpg";
import ahorroDualMobile from "./../../imagenes/slider/ahorro-dual-mobile.jpg";
import ahorroDualDesktop from "./../../imagenes/slider/ahorro-dual-Desktop.png";
// import caramelosNavidadDesktop from "./../../imagenes/slider/caramelos_navidad_desktop.png";
// import caramelosNavidadMobile from "./../../imagenes/slider/caramelos_navidad_mobile.png";
// import globalWeekDesktop from "./../../imagenes/slider/globalWeek-desktop.jpg";
// import globalWeekMobile from "./../../imagenes/slider/globalWeek-mobile.jpg";
import futuSaludDesktop from "./../../imagenes/slider/futusalud-desktop.png";
import futuSaludMobile from "./../../imagenes/slider/futusalud-mobile.png";
// import pasaporteAhorroDesktop from "./../../imagenes/slider/pasaporte_ahorro.jpg";
// import pasaporteAhorro2Desktop from "./../../imagenes/slider/pasaporte_ahorro_2.jpg";
// import pasaporteAhorroMobile from "./../../imagenes/slider/pasaporteAhorroMobile.png";
import segmentoDesktop from "./../../imagenes/slider/segmentoDesktop.png";
import segmentoMobile from "./../../imagenes/slider/segmentoMobile.png";
import solidezFinancieraDesktop from "./../../imagenes/slider/solidezFinancieraDesktop.png";
import solidezFinancieraMobile from "./../../imagenes/slider/solidezFinancieraMobile.png";
import vacantesDesktop from "./../../imagenes/slider/vacantes-laboral-desktop.png";
import vacantesMobile from "./../../imagenes/slider/vacantes-laboral-mobile.png";
import antilavadoDesktop from "./../../imagenes/slider/antilavado-desktop.png";
import antilavadoMobile from "./../../imagenes/slider/antilavado-mobile.jpg";
import guardianesAhorroDesktop from "./../../imagenes/slider/guardianes-ahorro-desktop.png";
import guardianesAhorroMobile from "./../../imagenes/slider/guardianes-ahorro-mobile.png";
import calificacionDesktop from "./../../imagenes/slider/calificacion-riesgo-desktop.png";
import calificacionMobile from "./../../imagenes/slider/calificacion-riesgo-desktop.png";
import cursoEnfermeriaDesktop from "./../../imagenes/slider/curso-enfermeria-desktop.png";
import cursoEnfermeriaMobile from "./../../imagenes/slider/curso-enfermeria-mobile.png";

// import convocatoriaMarzoMobile from "./../../imagenes/slider/convocatoria-mobil.png";
// import convocatoriaMarzoDesktop from "./../../imagenes/slider/convocatoria-asamblea.png";

// import convocatoriaDesktop from "./../../imagenes/slider/convocatoriaDesktop.png";
// import convocatoriaMobile from "./../../imagenes/slider/convocatoriaDesktop.png";
// import consultaVotacionDesktop from "./../../imagenes/slider/consulta-votacion-desktop.png";
// import consultaVotacionMobile from "./../../imagenes/slider/consulta-votacion-mobile.png";
// import conoceRepresentanteDesktop from "./../../imagenes/slider/conoce-representante-desktop.png";
// import conoceRepresentanteMobile from "./../../imagenes/slider/conoce-representante-mobile.png";

class Slider extends React.Component {
  render() {
    const slides = [
      // {
      //   link: "/futu-aniversario",
      //   imgDesktop: creditofutuaniversarioDesktop,
      //   imgMobile: creditofutuaniversarioMobile,
      //   target: false,
      // },
      // {
      //   link: "/convocatoria",
      //   imgDesktop: convocatoriaMarzoDesktop,
      //   imgMobile: convocatoriaMarzoMobile,
      //   target: true,
      // },
      // {
      //   link: "https://futurolamanense.fin.ec/docs/CONVOCATORIA_MARZO.pdf",
      //   imgDesktop: antilavadoDesktop,
      //   imgMobile: antilavadoMobile,
      //   target: true,
      // },
      // {
      //   link: "https://forms.gle/8y49CdBHVAqpLXay7",
      //   imgDesktop: cursoEnfermeriaDesktop,
      //   imgMobile: cursoEnfermeriaMobile,
      //   target: true,
      // },
      // {
      //   link: "#",
      //   imgDesktop: calificacionDesktop,
      //   imgMobile: calificacionMobile,
      //   target: false,
      // },
      {
        link: "/guardianes-del-ahorro",
        imgDesktop: guardianesAhorroDesktop,
        imgMobile: guardianesAhorroMobile,
        target: false,
      },
      // {
      //   link: "/deposito-plazo-fijo",
      //   imgDesktop: invierteutilidadesDesktop,
      //   imgMobile: invierteutilidadesMobile,
      //   target: false,
      // },
      {
        link: "/noticias?id_category=30",
        imgDesktop: antilavadoDesktop,
        imgMobile: antilavadoMobile,
        target: false,
      },
      {
        link: "/job-offersList",
        imgDesktop: vacantesDesktop,
        imgMobile: vacantesMobile,
        target: false,
      },
      // {
      //   link: "#",
      //   imgDesktop: globalWeekDesktop,
      //   imgMobile: globalWeekMobile,
      //   target: false,
      // },
      // {
      //   link: "https://futurolamanense.fin.ec/convocatoriaFLM",
      //   imgDesktop: convocatoriaDesktop,
      //   imgMobile: convocatoriaMobile,
      //   target: true,
      // },
      // {
      //   link: "https://futurolamanense.fin.ec/convocatoriaFLM/#/home#votacion",
      //   imgDesktop: consultaVotacionDesktop,
      //   imgMobile: consultaVotacionMobile,
      //   target: true,
      // },
      // {
      //   link: "#",
      //   imgDesktop: caramelosNavidadDesktop,
      //   imgMobile: caramelosNavidadMobile,
      //   target: false,
      // },
      {
        link: "/futu-hogar",
        imgDesktop: creditoFutuHogarDesktop,
        imgMobile: creditoFutuHogarMobile,
        target: false,
      },
      // {
      //   link: "/futu-navideno",
      //   imgDesktop: creditoFutuNavidenoDesktop,
      //   imgMobile: creditoFutuNavidenoMobile,
      //   target: false,
      // },
      // {
      //   link: "#",
      //   imgDesktop: decimosDesktop,
      //   imgMobile: decimosMobile,
      //   target: false,
      // },
      {
        link: "/credito-futu-unido",
        imgDesktop: creditoFutuUnidoDesktop,
        imgMobile: creditoFutuUnidoMobile,
        target: false,
      },
      // {
      //   link: "/credito-futuro-sobre-ruedas",
      //   imgDesktop: creditoFutuSobreRuedaDesktop,
      //   imgMobile: creditoFutuSobreRuedaMobile,
      //   target: false,
      // },
      // {
      //   link: "https://futurolamanense.fin.ec/convocatoriaFLM/#/home#candidatos",
      //   imgDesktop: conoceRepresentanteDesktop,
      //   imgMobile: conoceRepresentanteMobile,
      //   target: true,
      // },
      {
        link: "#",
        imgDesktop: segmentoDesktop,
        imgMobile: segmentoMobile,
        target: false,
      },
      // {
      //   link: "/pasaporte-ahorro",
      //   imgDesktop: pasaporteAhorro2Desktop,
      //   imgMobile: pasaporteAhorroMobile,
      //   target: false,
      // },
      {
        link: "#",
        imgDesktop: solidezFinancieraDesktop,
        imgMobile: solidezFinancieraMobile,
        target: false,
      },
      {
        link: "/cuenta-ahorros",
        imgDesktop: cuentaAhorroDesktop,
        imgMobile: cuentaAhorroMobile,
        target: false,
      },
      // {
      //   link: "/futu-auto",
      //   imgDesktop: creditoFutuautoDesktop,
      //   imgMobile: creditoFutuautoMobile,
      //   target: false,
      // },
      {
        link: "/futu-salud",
        imgDesktop: futuSaludDesktop,
        imgMobile: futuSaludMobile,
        target: false,
      },
      // {
      //   link: "https://pagos.facilito.com.ec/aplicacion/futurolamanense",
      //   imgDesktop: facilitoDesktop,
      //   imgMobile: facilitoMobile,
      //   target: true,
      // },
      {
        link: "https://pagos.facilito.com.ec/aplicacion/futurolamanense",
        imgDesktop: facilitoDesktop2,
        imgMobile: facilitoMobile,
        target: true,
      },
      {
        link: "/ahorro-dual",
        imgDesktop: ahorroDualDesktop,
        imgMobile: ahorroDualMobile,
        target: false,
      },
      {
        link: "/ahorro-campo",
        imgDesktop: ahorroCampoDesktop,
        imgMobile: ahorroCampoMobile,
        target: false,
      },
      {
        link: "/futuro-premia",
        imgDesktop: acumulaPuntoDesktop,
        imgMobile: acumulaPuntoMobile,
        target: false,
      },
      {
        link: "https://solicitudcredito.futurolamanense.fin.ec/",
        imgDesktop: creditoenlineaDesktop,
        imgMobile: creditoenlineaMobile,
        target: true,
      },
      {
        link: "/medicina-general",
        imgDesktop: medicinaGeneralDesktop,
        imgMobile: medicinaGeneralMobile,
        target: false,
      },
      // {
      //   link: "/eco-futuro",
      //   imgDesktop: creditoecofuturoDesktop,
      //   imgMobile: creditoecofuturoMobile,
      //   target: false,
      // },
      {
        link: "/educacion-financiera",
        imgDesktop: educacionFinancieraDesktop,
        imgMobile: educacionFinancieraMobile,
        target: false,
      },
      {
        link: "/credito-premium",
        imgDesktop: creditoPremiumDesktop,
        imgMobile: creditoPremiumMobile,
        target: false,
      },
      {
        link: "/credito-futuconfianza",
        imgDesktop: creditoFutuconfianzaDesktop,
        imgMobile: creditoFutuconfianzaMobile,
        target: false,
      },
      {
        link: "/ahorro-inclusion",
        imgDesktop: ahorroInclusionDesktop,
        imgMobile: ahorroInclusionMobile,
        target: false,
      },
      {
        link: "/saras",
        imgDesktop: saraDesktop,
        imgMobile: saraMobile,
        target: false,
      },
    ];

    return (
      <section id="sliderc" className="p-0">
        <Swiper
          className="mySwiper"
          modules={[Navigation, Autoplay, EffectFade, Pagination]}
          navigation={true}
          autoplay={{
            delay: 5000,
            disableOnInteraction: false,
          }}
          pagination={{
            clickable: true,
          }}
          slidesPerView={1}
          slidesPerGroupSkip={1}
          effect={"fade"}
          loop="true"
        >
          {slides.map((slide, index) => (
            <SwiperSlide key={index}>
              {slide.target ? (
                <a href={slide.link} target="_blank" rel="noreferrer">
                  <img
                    src={slide.imgDesktop}
                    className="image-slider-pc"
                    alt={`Slide ${index} - Desktop`}
                  />
                  <img
                    src={slide.imgMobile}
                    className="image-slider-mobile"
                    alt={`Slide ${index} - Mobile`}
                  />
                </a>
              ) : (
                <a href={slide.link}>
                  <img
                    src={slide.imgDesktop}
                    className="image-slider-pc"
                    alt={`Slide ${index} - Desktop`}
                  />
                  <img
                    src={slide.imgMobile}
                    className="image-slider-mobile"
                    alt={`Slide ${index} - Mobile`}
                  />
                </a>
              )}
            </SwiperSlide>
          ))}
        </Swiper>
      </section>
    );
  }
}

export default Slider;
